import * as types from './ActionTypes';
import { create } from 'axios';
import _ from 'lodash';
import { addToast } from './toast.action';
import { applyLotFilter } from './filter.action';

const ajax = create({
  contentType: 'application/json',
  baseURL: process.env.REACT_APP_CORE_USER_API_URL
});

ajax.defaults.withCredentials = true;

export const getLots = () => dispatch => {
  dispatch({
    type: types.GET_LOTS_PENDING
  });
  ajax.get('/organizations/lots')
    .then(resp => {
      dispatch({
        type: types.GET_LOTS_SUCCESS,
        payload: resp.data.associations
      });
    })
    .catch(error => {
      dispatch({
        type: types.GET_LOTS_REJECTED,
        payload: error
      });
      dispatch({
        type: types.SET_ERROR_DIALOG,
        payload: {
          error,
          visible: true
        }
      });
    });
};

export const updateLot = (data) => dispatch => {
  dispatch({
    type: types.UPDATE_LOT_PENDING
  });
  const editLot = data.edits;
  const originalLot = data.original;
  const originalPartyKeys = originalLot.organizations ? originalLot.organizations.map(j => j.partyKey) : [];
  const editPartyKeys = editLot.organizations.map(j => j.externalKey);
  const postKeys = editPartyKeys.filter(x => !originalPartyKeys.includes(x));
  const delKeys = originalPartyKeys.filter(x => !editPartyKeys.includes(x));
  const postBody = {
    'associations': [
      {
        parkingNodeKey: editLot.externalKey,
        organizations: postKeys
      }
    ]
  };
  const delBody = {
    data: {
      'associations': [
        {
          parkingNodeKey: editLot.externalKey,
          organizations: delKeys
        }
      ]
    }
  };
  const successToast = `Lot/Garage: ${originalLot && originalLot.displayName} has been edited`;

  if (!_.isEmpty(postKeys) && !_.isEmpty(delKeys)) {
    ajax.post('/organizations/lots', postBody)
      .then(() => {
        return dispatch({
          type: types.UPDATE_LOT_SUCCESS
        });
      })
      .then(() => {
        return ajax.delete('/organizations/lots', delBody );
      })
      .then(() => {
        dispatch(applyLotFilter(null));
        dispatch(getLots());
      })
      .then(() => {
        return dispatch(addToast({
          toasts: [{
            action: 'dismiss',
            text: successToast
          }]
        }));
      }).catch(error => {
        dispatch({
          type: types.UPDATE_LOT_REJECTED,
          payload: error
        });
        dispatch({
          type: types.SET_ERROR_DIALOG,
          payload: {
            error,
            visible: true
          }
        });
      });
  } else if (!_.isEmpty(postKeys) && _.isEmpty(delKeys)) {
    ajax.post('/organizations/lots', postBody)
      .then(() => {
        return dispatch({
          type: types.UPDATE_LOT_SUCCESS
        });
      })
      .then(() => {
        dispatch(applyLotFilter(null));
        dispatch(getLots());
      })
      .then(() => {
        return dispatch(addToast({
          autohide: false,
          toasts: [{
            action: 'dismiss',
            text: successToast
          }]
        }));
      })
      .catch(error => {
        dispatch({
          type: types.UPDATE_LOT_REJECTED,
          payload: error
        });
        dispatch({
          type: types.SET_ERROR_DIALOG,
          payload: {
            error,
            visible: true
          }
        });
      });
  } else if (_.isEmpty(postKeys) && !_.isEmpty(delKeys)) {
    ajax.delete('/organizations/lots', delBody)
      .then(() => {
        return dispatch({
          type: types.UPDATE_LOT_SUCCESS
        });
      })
      .then(() => {
        dispatch(applyLotFilter(null));
        dispatch(getLots());
      }).then(() => {
        return dispatch(addToast({
          autohideTimeout: 10000,
          toasts: [{
            action: 'dismiss',
            text: successToast
          }]
        }));
      })
      .catch(error => {
        dispatch({
          type: types.UPDATE_LOT_REJECTED,
          payload: error
        });
        dispatch({
          type: types.SET_ERROR_DIALOG,
          payload: {
            error,
            visible: true
          }
        });
      });
  }
};



// WEBPACK FOOTER //
// ./src/actions/lots.action.js